import { withRouter } from '@/checkout-instore-legacy/utils/withRouter'

import { withMediaQuery } from '@/checkout-instore-legacy/utils/mediaQuery'
import withOrderFormAndVendor from '@/checkout-instore-legacy/order/withOrderFormAndVendor'
import { SearchPage } from './SearchPage'

export default withOrderFormAndVendor(withMediaQuery(withRouter(SearchPage)))
